






import CoNotFound from '@/components/Templates/User/NotFound/CoNotFound.vue';

export default {
    name: 'NotFoundPage',
    components: {
        CoNotFound,
    },
};
